import script from "./PaymentStatusesView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentStatusesView.vue?vue&type=script&setup=true&lang=js"

import "./PaymentStatusesView.vue?vue&type=style&index=0&id=83b25694&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83b25694"]])

export default __exports__